import React, { useCallback, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import LabeledContainer from '../../../../common/LabeledContainer';
import TextInput, { TextInputType } from '../../../../../atoms/TextInput';
import BooksCenteringUnderLineMessage from '../BooksCenteringUnderLineMessage';
import { ErrorType } from '../../../../../domain/entities/Auth';
import { CreateUserWithResvQuery } from '../../../../../hooks/api/auth';
import ErrorMessage from '../InputCreateUserErrorMessage';
import { RSButton } from 'src/reservation-page/RSButton';

interface Props {
  postable: boolean;
  reservationId: number;
  errors?: ErrorType[];
  email: string;
  onSubmit: (query: CreateUserWithResvQuery) => void;
}

const InputCompletionCreateUser: React.FC<Props> = (props) => {
  const intl = useIntl();
  const [email, setEmail] = useState<string>(props.email);
  const [password, setPassword] = useState<string>('');

  const submittable = useMemo(() => {
    return email && password;
  }, [email, password]);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const {
        currentTarget: { name, value },
      } = e;

      switch (name) {
        case 'email':
          setEmail(value);
          break;
        case 'password':
          setPassword(value);
          break;
        default:
          break;
      }
    },
    [setEmail, setPassword],
  );

  const handleSubmit = useCallback(async () => {
    const { reservationId, onSubmit } = props;
    if (!reservationId) {
      return;
    }
    onSubmit({ reservationId, password });
  }, [props, password]);

  const { postable, errors } = props;

  return (
    <div>
      <BooksCenteringUnderLineMessage>
        {intl.formatMessage({
          id: 'books.formsLabel.createUserSuggest',
        })}
      </BooksCenteringUnderLineMessage>
      <LabeledContainer
        label={intl.formatMessage({
          id: 'books.formsLabel.email',
        })}
      >
        <TextInput
          type={TextInputType.Email}
          name={'email'}
          value={email}
          disabled={true}
          setValue={true}
          onChange={handleChange}
        />
      </LabeledContainer>
      <LabeledContainer
        label={intl.formatMessage({
          id: 'books.formsLabel.password',
        })}
      >
        <TextInput
          type={TextInputType.Password}
          name={'password'}
          value={password}
          onChange={handleChange}
          placeholder={intl.formatMessage({
            id: 'books.formsLabel.passwordPlaceholder',
          })}
        />
      </LabeledContainer>
      <ErrorMessage errors={errors} />
      <div className="px-[18px] py-5">
        <RSButton
          variant="basic"
          isBlock
          isLoading={!postable}
          disabled={!submittable || !postable}
          type="button"
          value={intl.formatMessage({ id: 'books.submitLabel.userResist' })}
          onClick={handleSubmit}
        >
          {intl.formatMessage({ id: 'books.submitLabel.userResist' })}
        </RSButton>
      </div>
    </div>
  );
};

export default InputCompletionCreateUser;
